import { createCrudActions } from '../utils/crudGenerator';

const formatNotes = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchNotes,
    create: createNote,
    update: updateNote,
    delete: deleteNotes
} = createCrudActions('NOTE', "Anotacione", formatNotes);